<script lang="ts">
  import { Button, Col } from "sveltestrap";
  import { Bookmarkfilter, href } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
  import TasksUser from "./TasksUser.svelte";
  import NewTasks from "./NewTasks.svelte";
  import ViewsTab from "./ViewsTab.svelte";
  import TagsTab from "./TagsTab.svelte";
  let open:boolean = false
</script>

<Col xl="3" class="box-col-4 xl-30">
  <div class="email-sidebar">
    <Button color="primary" class="email-aside-toggle" {href} on:click={()=> open = !open}>{Bookmarkfilter}</Button>
    <div class="email-left-aside {open ? "open" : ""}">
      <Card>
        <div slot="contentbody">
          <div class="email-app-sidebar left-bookmark">
            <TasksUser />
            <ul class="nav main-menu" role="tablist">
              <NewTasks />
              <ViewsTab />
              <li>
                <hr />
              </li>
              <TagsTab />
            </ul>
          </div>
        </div>
      </Card>
    </div>
  </div>
</Col>
